import { render, staticRenderFns } from "./sclcsQuery.vue?vue&type=template&id=27d808bc&scoped=true&"
import script from "./sclcsQuery.vue?vue&type=script&lang=js&"
export * from "./sclcsQuery.vue?vue&type=script&lang=js&"
import style0 from "./sclcsQuery.vue?vue&type=style&index=0&id=27d808bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d808bc",
  null
  
)

export default component.exports